import type { ComboVariation, Proposta, PropostaItem } from '@/types'
import type { ComboValue } from './types'

export type BuildProposalPayloadInput = {
  dealId: string
  itens: PropostaItem[]
  comboValues: ComboValue[]
  comboVariations: ComboVariation[]
  validadeDias: number
  observacoes: string
  desconto: number
  subtotal: number
  totalFinal: number
  existingDadosRaw?: string
}

export function buildProposalPayload(input: BuildProposalPayloadInput) {
  let existingDados: Record<string, unknown> = {}
  if (input.existingDadosRaw) {
    try {
      existingDados = JSON.parse(input.existingDadosRaw) as unknown as Record<string, unknown>
    } catch {
      existingDados = {}
    }
  }

  const sanitizedVariations = input.comboVariations.filter((v) => v.itemIds?.length)
  const dadosObj: Record<string, unknown> = { ...existingDados }
  if (sanitizedVariations.length > 0) {
    dadosObj.comboVariations = sanitizedVariations
  } else {
    delete dadosObj.comboVariations
  }

  return {
    dealId: input.dealId,
    valor: input.totalFinal,
    validade: input.validadeDias,
    observacoes: input.observacoes,
    desconto: input.desconto,
    subtotal: input.subtotal,
    totalFinal: input.totalFinal,
    dados: JSON.stringify(dadosObj),
    items: input.itens.map(
      ({ id, descricao, tipo, quantidade, valorUnitario, total, comboGroupId, comboFinalPrice, ...rest }) => ({
        id,
        nome: descricao,
        descricao,
        tipo,
        quantidade,
        valor: Math.round(valorUnitario * 100),
        valorUnitario,
        total,
        comboGroupId,
        comboFinalPrice,
        ...rest,
      }),
    ),
    itens: input.itens.map(({ id, ...rest }) => rest),
    combos: input.comboValues.map(({ id, nome, desconto, itemIds }) => ({
      id,
      nome,
      desconto,
      itemIds,
    })),
  }
}

export function getExistingDadosRaw(proposals: Proposta[], editingId: string | null): string | undefined {
  if (!editingId) return undefined
  const row = proposals.find((p) => p.id === editingId) as Proposta & { dados?: string }
  return row?.dados
}
